import "./BCT - Marvin Icon_F.png"
import "./BCT - Marvin Icon_F.svg"

document.addEventListener("DOMContentLoaded", function() {
  let chatForm = document.querySelector('.chat-form')

  if (chatForm) {
    chatForm.addEventListener('submit', handleChatSubmit)
    let messages = document.querySelectorAll('.chat-messages > .chat-message')
    if (!(messages && messages.length)) {
      fetch('/ai_chat/chat').then(res => res.text()).then(html => {
        document.querySelector('.chat-messages').innerHTML = html
        let popup = chatForm.closest('.chat-popup')
        if (popup && getChatStatus() == 'open') {
          popup.classList.add('is-open')
        }
        scrollChatToBottom()
      })
    }

    chatForm.addEventListener('keypress', e => {
      if (e.key == 'Enter') {
        sendMsg(chatForm)
        e.preventDefault()
      }
    })
  }

  let chatPopup = document.querySelector('.chat-popup')
  let openChatButton = document.querySelector('.open-chat-button')
  if (chatPopup && openChatButton) {
    chatPopup.querySelector('.chat-popup-close').addEventListener('click', () => {
      chatPopup.classList.remove('is-open')
      setChatStatus('closed')
    })
    openChatButton.addEventListener('click', () => {
      let isOpen = chatPopup.classList.toggle('is-open')
      setChatStatus(isOpen ? 'open' : 'closed')
      if (isOpen) {
        scrollChatToBottom()
        // Skip autofocus on touch devices so the keyboard doesn't cover the panel
        let textarea = chatPopup.querySelector('textarea')
        if (textarea && window.matchMedia('(hover: hover)').matches) {
          textarea.focus()
        }
      }
    })
  }

  let showChat = document.querySelector('.js-show-chat')
  let showItinerary = document.querySelector('.js-show-itinerary')
  let chatContainer = document.querySelector('.chat-container')
  showChat && showChat.addEventListener('click', e => {
    showChat.classList.add('active');
    showItinerary.classList.remove('active');
    chatContainer.classList.add('active');
  })
  showItinerary && showItinerary.addEventListener('click', e => {
    showChat.classList.remove('active');
    showItinerary.classList.add('active');
    chatContainer.classList.remove('active');
  })
})

function getChatStatus() {
  let match = document.cookie.match(/(?:^|;\s*)ai_chat_status=([^;]*)/)
  return match ? match[1] : 'open'
}

function setChatStatus(status) {
  document.cookie = `ai_chat_status=${status}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`
}

function handleChatSubmit(e) {
  let form = e.target
  showSpinner(form)
  let msgsContainer = form.parentNode.querySelector('.chat-messages')
  if (form.dataset.hasOwnProperty('async')) {
    e.preventDefault();
    let params = new URLSearchParams(new FormData(form))
    if (e.submitter && e.submitter.name && e.submitter.value) {
      params.set(e.submitter.name, e.submitter.value)
    }
    fetch(`/ai_chat/chat?${params}`)
      .then(res => res.text())
      .then(html => {
        msgsContainer.innerHTML = html
        scrollChatToBottom()
        hideSpinner(form)
      })
  }
}

function scrollChatToBottom() {
  let container = document.querySelector('.chat-messages')
  container && container.scrollTo(0, container.scrollHeight)
}

function sendMsg(chatForm) {
  let textarea = chatForm.querySelector('textarea')
  let msg = textarea && textarea.value

  if (!msg.trim()) return

  let messagesContainer = document.querySelector('.chat-messages')
  if (!messagesContainer) return

  let msgBubble = document.createElement('div')
  msgBubble.classList.add('chat-message', 'user')
  msgBubble.textContent = msg
  messagesContainer.append(msgBubble)
  scrollChatToBottom()

  chatForm.requestSubmit()
  textarea.value = ''
}

function showSpinner(chatForm) {
  let spinner = document.createElement('div')
  let msgsContainer = document.querySelector('.chat-messages')
  spinner.classList.add('chat-bubble')
  spinner.classList.add('chat-message')
  spinner.classList.add('assistant')
  spinner.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="24" viewBox="0 0 448 512"><path d="M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"/></svg>'
  spinner.role = 'status'
  msgsContainer.append(spinner)
  msgsContainer.scrollTop = msgsContainer.scrollHeight;
}

function hideSpinner(chatForm) {
  chatForm.querySelector('.chat-bubble').remove()
}
